import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { color } from '@shared/constants/Styles';

const DefaultStyles = styled.div`
    button,
    a {
        &:focus {
            outline: ${color.accent} auto 2px;
        }
    }
    a {
        text-decoration: none;
    }
    * {
        font-family:
            'Archivo',
            system-ui,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            Ubuntu,
            'Helvetica Neue',
            Oxygen,
            Cantarell,
            sans-serif;
    }
`;

export const MixinFocusVisible = css`
    &:focus-visible {
        outline: 2px dashed ${color.tertiary_updated} !important;
        outline-offset: 2px;
        z-index: 100;
    }
`;

export const MixinVisuallyHidden = css`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    padding: 0;
    margin: 0;
`;

const fadeIn = keyframes`
    from {
        opacity: 0;

    }
    to {
        opacity: 1;

    }
`;

export const MixinAnimationFade = css`
    animation: ${fadeIn} 0.5s ease-in-out;
`;

export const MixinAnimationFadeFast = css`
    animation: ${fadeIn} 0.1s ease-in-out;
`;

export const AnimateFade = styled.div`
    ${MixinAnimationFade};
`;

export default DefaultStyles;
